import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const MemberList = Loadable(
  lazy(() => import("features/member/components/MemberList"))
);
const MemberPage = Loadable(
  lazy(() => import("features/member/components/Page"))
);
const MemberDetail = Loadable(
  lazy(() => import("features/member/components/MemberDetails"))
);
const ErpAutoImportMemberPage = Loadable(
  lazy(() => import("features/importMember/components/ErpAutoImportMember"))
);
const routes = {
  path: "member",
  children: [
    { path: "", element: <MemberList /> },
    { path: "add", element: <MemberPage /> },
    { path: "edit/:memberId?", element: <MemberPage /> },
    { path: "copy/:copyMemberId?", element: <MemberPage /> },
    { path: "memberDetail", element: <MemberDetail /> },
    { path: "erpAutoImportMember", element: <ErpAutoImportMemberPage /> },
  ],
};

export default routes;
